// AdditionalSocialPostActions.js - Additional action buttons to display alongside ApprovalDropdown

import React, { useState } from "react";
import RepostDropdown from "./RepostDropdown";

const AdditionalSocialPostActions = ({ 
  post, 
  onEdit, 
  onReSmack, 
  onArchive,
  onUnarchive,
  onRepostNow,
  onRepostSchedule,
  isReSmackLoading = false 
}) => {
  const [isArchiving, setIsArchiving] = useState(false);
  const [isUnarchiving, setIsUnarchiving] = useState(false);

  const handleArchive = async () => {
    if (window.confirm('Are you sure you want to archive this post? It will be moved to the archived section.')) {
      setIsArchiving(true);
      try {
        await onArchive(post);
      } finally {
        setIsArchiving(false);
      }
    }
  };

  const handleUnarchive = async () => {
    if (window.confirm('This will move the post back to Pending status. Continue?')) {
      setIsUnarchiving(true);
      try {
        await onUnarchive(post);
      } finally {
        setIsUnarchiving(false);
      }
    }
  };

  const handleReSmack = async () => {
    if (window.confirm('This will regenerate the post content. Your current edits will be lost. Continue?')) {
      await onReSmack(post);
    }
  };

  // For archived posts, show edit and unarchive
  if (post.status === 'archived') {
    return (
      <div className="additional-social-post-actions" id={`additionalSocialPostActions-${post.providerKey || post.provider}`}>
        <button
          onClick={() => onEdit(post)}
          className="social-post-edit-btn"
          id={`socialPostEditBtn-${post.providerKey || post.provider}`}
        >
          Edit
        </button>
        <button
          onClick={handleUnarchive}
          className="social-post-unarchive-btn"
          id={`socialPostUnarchiveBtn-${post.providerKey || post.provider}`}
          disabled={isUnarchiving}
        >
          {isUnarchiving ? "Unarchiving..." : "Unarchive"}
        </button>
      </div>
    );
  }

  // For published posts, show edit, repost dropdown, and archive
  if (post.status === 'published') {
    return (
      <div className="additional-social-post-actions" id={`additionalSocialPostActions-${post.provider}`}>
        <RepostDropdown
          post={post}
          onPostNow={onRepostNow}
          onSchedule={onRepostSchedule}
        />
        <button
          onClick={() => onEdit(post)}
          className="social-post-edit-btn"
          id={`socialPostEditBtn-${post.providerKey || post.provider}`}
        >
          Edit
        </button>
        <button
          onClick={handleArchive}
          className="social-post-archive-btn"
          id={`socialPostArchiveBtn-${post.providerKey || post.provider}`}
          disabled={isArchiving}
        >
          {isArchiving ? "Archiving..." : "Archive"}
        </button>
      </div>
    );
  }

  return (
    <div className="additional-social-post-actions" id={`additionalSocialPostActions-${post.providerKey || post.provider}`}>
      <button
        onClick={() => onEdit(post)}
        className="social-post-edit-btn"
        id={`socialPostEditBtn-${post.providerKey || post.provider}`}
      >
        Edit
      </button>
      
      <button
        onClick={handleReSmack}
        className="social-post-resmack-btn"
        id={`socialPostReSmackBtn-${post.providerKey || post.provider}`}
        disabled={isReSmackLoading}
      >
        {isReSmackLoading ? "Regenerating..." : "ReSmack"}
      </button>
      
      <button
        onClick={handleArchive}
        className="social-post-archive-btn"
        id={`socialPostArchiveBtn-${post.providerKey || post.provider}`}
        disabled={isArchiving}
      >
        {isArchiving ? "Archiving..." : "Archive"}
      </button>
    </div>
  );
};

export default AdditionalSocialPostActions;